<div fxLayout="column" fxLayout.gt-sm="row">
	<div class="wrapper">
		<iframe
			#editor
			data-cy="customersCanvasIframe"
			[ngClass]="{ loaded: isEditorLoaded }"
			frameborder="0"
			i18n-title="@@ProductEditorIframeTitle"
			title="Design Tool"
			fxFlex
		></iframe>
	</div>
	@if (hasSchemaForm$ | async) {
		<aside fxLayout="column" fxFlex="auto" fxFlex.gt-sm="400px">
			<g-editor-schema-form
				[disabled]="!isEditorLoaded"
				[product]="(productEditor.product$ | async) ?? undefined"
				[initialValues]="schemaFormInitialValues"
				(modelChange)="onSchemaFormChange($event)"
				(errorChange)="onSchemaFormError($event)"
			/>
		</aside>
	}
</div>
@if (showSpinner) {
	<g-loading-spinner transparent />
}
